/**
 * @file 官方流程actions
 */
import {Url} from '@/utils/api.js';
import {post, get} from '@/utils/decorate/request';
import toast from '@/utils/decorate/toast';

export default {
    changeOfficialFollower({commit, state}, userInfo) {
        let url = Url.changeOfficialFollowerUrl;
        let topicId = state.topicData.topicInfo.topicId;
        return post(url, {topicId, userId: userInfo.id})
            .then(data => {
                toast.success('变更人员成功');
                commit('changeFollowerState', data.isFollower);
                commit('changeOfficialFollowerName', userInfo);
            })
            .catch(errmsg => toast.error(errmsg));
    },
    establishList({state}) {
        let url = Url.officialicafeaddUrl;
        let topicId = state.topicData.topicInfo.topicId;
        return post(url, {topicId})
            .then(data => {
                toast.success('iCafe创建成功');
                state.topicData.ext.qaOfficialInfo.icafeUrl = data;
            })
            .catch(errmsg => toast.error(errmsg));
    },
    changeIssueProcess({state, commit}, process) {
        let url = Url.officialProcessUpdate;
        let topicId = state.topicData.topicInfo.topicId;
        return post(url, {topicId, process})
            .then(() => {
                toast.success('更改状态成功');
                commit('changeIssueState', process);
            })
            .catch(errmsg => toast.error(errmsg));
    }
};
